<template>
  <div class="ArtifactPage">
    <div v-if="artifact">
      <div class="ArtifactContainer">
        <div class="ArtifactContainer__header">
          <v-btn icon small @click.stop="goToWorkspace" style="margin: 2px">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <span style="font-weight: bold; font-size: 16pt;">{{ artifact.title }}</span>
        </div>
        <div class="ArtifactContainer__content">
          <v-tabs
            v-model="selectedTab"
            align-tabs="center"
          >

            <v-tab :value="1">View</v-tab>
            <v-tab :value="2">Raw</v-tab>

            <v-tab-item class="ArtifactContainer__contentTab">
              <div class="ArtifactContainer__htmlContent">
                <iframe v-if="artifact.type === 'html'" :srcdoc="artifact.content" frameborder="0" style="height: 70vh; width: 100%"></iframe>
                <span v-if="artifact.type !== 'html'">
                  <div v-html="renderMarkdown(artifact.content)" style="height: 70vh; width: 100%; overflow-y: auto">
                  </div>
                </span>
              </div>
            </v-tab-item>
            <v-tab-item class="ArtifactContainer__contentTab">
              <div class="ArtifactContainer__rawContent">
              <span style="word-wrap: break-word;">
               {{ artifact.content }}
              </span>
              </div>
            </v-tab-item>

          </v-tabs>
        </div>
      </div>
    </div>
    <loader v-if="loading"></loader>
  </div>
</template>

<script>
import * as moment from 'moment/moment';
import { createNamespacedHelpers } from 'vuex';
import Loader from '@/components/loader/loader.vue';
import markdownit from 'markdown-it';

const {
  mapActions: AIChatActions,
} = createNamespacedHelpers("AIChat");

export default {
  name: 'ArtifactPage',
  components: { Loader },
  props: {},
  data() {
    return {
      artifact: null,
      loading: false,
      selectedTab: '1',
    }
  },
  computed: {},
  methods: {
    ...AIChatActions(['getAgentArtifact']),
    getTime(date) {
      return moment(date).fromNow();
    },
    renderMarkdown(text) {
      const md = markdownit({
        breaks: true,
        linkify: true,
      });
      return md.render(text);
    },
    async loadArtifact(artifactId) {
      this.loading = true;
      this.artifact = await this.getAgentArtifact({
        artifactId: artifactId,
      })
      this.loading = false;
    },
    goToWorkspace() {
      this.$router.push({ path: `/agents/${this.artifact.workspaceId}` });
    }
  },
  mounted() {
    const artifactId = this.$route.query.artifact;
    this.loadArtifact(artifactId);
  }
};
</script>

<style scoped lang="scss">
@import './artifact-page';
</style>

